import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import style from './style.module.less';
import { MDash } from 'ui-components/components/mdash';

const name = <FormattedMessage {...messages.allocatedColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.allocatedColumnHeader,
  name,
  render: (data) => (
    <div className={style['right-align-column']}>
      {data.inventoryDisabled && <MDash />}
      {!data.inventoryDisabled && (data.inventory?.allocated ?? 0)}
    </div>
  ),
};
